import { Injectable } from '@angular/core';
import {HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse} from '@angular/common/http';
import {BehaviorSubject, catchError, filter, first, Observable, switchMap, take, throwError} from "rxjs";
import {ApiService} from "../services/api.service";
import {NotificationService} from "../services/notification.service";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private apiService: ApiService, private notificationService: NotificationService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    return next.handle(request).pipe(catchError(
      (error: HttpErrorResponse): Observable<any> => {
        this.apiService.setIsLoading(false);

        // Skip showing error notifications for 401 errors since AuthInterceptor handles them
        if (error.status === 401) {
          return throwError(() => error);
        }

        // Display error message in snackbar
        let errorMessage = 'Er is een fout opgetreden';

        if (error.error instanceof ErrorEvent) {
          // Client-side error
          errorMessage = error.error.message;
        } else {
          // Server-side error
          if (error.error?.message) {
            errorMessage = error.error.message;
          } else if (error.message) {
            errorMessage = error.message;
          } else if (error.status) {
            switch (error.status) {
              case 0:
                errorMessage = 'Kan geen verbinding maken met de server';
                break;
              case 400:
                errorMessage = 'Ongeldige aanvraag';
                break;
              case 403:
                errorMessage = 'Toegang geweigerd';
                break;
              case 404:
                errorMessage = 'Bron niet gevonden';
                break;
              case 500:
                errorMessage = 'Serverfout';
                break;
              default:
                errorMessage = `Fout ${error.status}: ${error.statusText}`;
            }
          }
        }

        this.notificationService.showError(errorMessage);

        return throwError(() => error);
      },
    ));
  }

}
